<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div
            v-if="loading"
            class="my-8 align-self-stretch d-flex align-center justify-center"
        >
            <spinner />
        </div>
        <div v-if="!loading">
            <div class="ufv-btn-voltar">
                <v-row justify="space-between">
                    <ViewBotaoVoltar @voltar="voltar" />
                    <router-link :to="{ name: 'DocArvore' }" target="_blank"
                        ><v-btn color="primary" text>
                            <v-icon class="mr-2">mdi-notebook</v-icon
                            >Documentação
                        </v-btn></router-link
                    >
                </v-row>
            </div>
            <div class="ufv-container-text">
                <div v-if="novaArvore" class="text-h4">Nova Árvore</div>
                <div v-if="!novaArvore" class="text-h4">Editar Árvore</div>
            </div>
            <v-form
                v-if="!testando"
                ref="form"
                v-model="formValido"
                class="mt-8"
            >
                <v-container>
                    <v-row>
                        <v-text-field
                            label="Nome"
                            v-model="arvoreAdmin.nome"
                            :rules="formRules.nome"
                        />
                    </v-row>
                    <v-row>
                        <v-file-input
                            label="Carregar Árvore à partir de arquivo"
                            accept=".yaml,.yml"
                            @change="textoLoaded"
                        ></v-file-input>
                    </v-row>
                    <v-row style="position: relative">
                        <div style="position: absolute; right: 30px; top: 20px">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="copyToClipBoard"
                                        :loading="copiando"
                                    >
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Copiar texto da árvore</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="download"
                                        :loading="copiando"
                                    >
                                        <v-icon>mdi-download</v-icon>
                                    </v-btn>
                                </template>
                                <span>Baixar arquivo</span>
                            </v-tooltip>
                        </div>
                        <codigo :texto="arvoreAdmin.texto" />
                    </v-row>
                    <v-row class="botoes flex-start">
                        <v-btn
                            :disabled="!restauravel"
                            :loading="restaurando"
                            @click="promptRestaurarArvore"
                            ><v-icon class="mr-2">mdi-restore</v-icon>Restaurar
                            Árvore</v-btn
                        >
                        <v-btn :disabled="!testavel" @click="testarArvore"
                            ><v-icon class="mr-2">mdi-test-tube</v-icon>Testar
                            Árvore</v-btn
                        >
                        <v-btn
                            :disabled="!lancavel"
                            :loading="lancando"
                            @click="promptLancarArvore"
                            ><v-icon class="mr-2">mdi-rocket-launch</v-icon
                            >Lançar Árvore</v-btn
                        >
                        <v-btn
                            :disabled="!desabilitavel"
                            :loading="desabilitando"
                            @click="desabilitarArvore"
                            ><v-icon class="mr-2">mdi-pause-circle</v-icon
                            >Desabilitar</v-btn
                        >
                        <v-btn
                            :disabled="!apagavel"
                            :loading="apagando"
                            @click="promptApagarArvore"
                            ><v-icon class="mr-2">mdi-delete</v-icon
                            >Apagar</v-btn
                        >
                        <v-btn @click="cancelar" :disabled="!cancelavel"
                            ><v-icon class="mr-2">mdi-cancel</v-icon
                            >Cancelar</v-btn
                        >
                        <v-btn
                            @click="salvar()"
                            :disabled="!salvavel"
                            :loading="salvando"
                            ><v-icon class="mr-2">mdi-content-save</v-icon
                            >Salvar</v-btn
                        >
                    </v-row>
                    <v-row>
                        <log-verificacao :mensagens="erros" />
                    </v-row>
                </v-container>
            </v-form>
            <v-container v-if="testando">
                <div class="text-h4">Testando árvore</div>
                <view-arvore
                    :servicoAtendimento="servicoTesteArvore"
                ></view-arvore>
            </v-container>
            <alerta-modal v-model="mostrarDialogo" :tipo="tipoDialogo">{{
                msgDialogo
            }}</alerta-modal>
            <yes-cancel-dialog
                v-model="mostrarYasCancelDialog"
                @ok="yesCancelDialogResolver('ok')"
                @cancelar="yesCancelDialogResolver('cancelar')"
                >{{ msgYesCancelDialog }}</yes-cancel-dialog
            >
        </div>
    </v-container>
</template>

<script>
import debounce from "lodash/debounce";
import { mapGetters, mapActions } from "vuex";
import Spinner from "../../../componentes/ui/Spinner";
import { getServicoArvoresInstance } from "../../../services/ServicosFactory";
import Codigo from "../../../componentes/ui/Codigo.vue";
import LogVerificacao from "./LogVerificacao.vue";
import ViewArvore from "../../atendimento/arvore/ViewArvore.vue";
import ServicoTesteArvore from "../../../services/ServicoTesteArvore";
import ViewBotaoVoltar from "../../atendimento/arvore/elementos/ViewBotaoVoltar.vue";
import AlertaModal from "../../../componentes/AlertaModal.vue";
import YesCancelDialog from "../../../componentes/YesCancelDialog.vue";

const servicoArvores = getServicoArvoresInstance();

const MSG_LANCAR =
    "Ao lançar esta versão, a árvore em produção será substituida. Deseja realmente lançar esta árvore?";

const MSG_RESTAURAR =
    "Ao restaurar a versão em produção, a árvore atual será substituida. Deseja realmente restaurar a árvore em produção?";

export default {
    name: "ArvoreForm",
    components: {
        Spinner,
        Codigo,
        LogVerificacao,
        "view-arvore": ViewArvore,
        ViewBotaoVoltar,
        "alerta-modal": AlertaModal,
        YesCancelDialog,
    },
    data() {
        return {
            loading: true,
            copiando: false,
            salvando: false,
            verificando: false,
            lancando: false,
            restaurando: false,
            apagando: false,
            desabilitando: false,
            mostrarDialogo: false,
            tipoDialogo: "",
            msgDialogo: "",
            mostrarYasCancelDialog: false,
            msgYesCancelDialog: "",
            yesCancelDialogResolver: null,
            erros: [],
            arvoreAdmin: {},
            arvoreSalva: {},
            arvoreEmEdicao: {},
            servicoTesteArvore: null,
            nomeJaExiste: false,
            formRules: {
                nome: [
                    (v) => !!v || "Este campo é obrigatório",
                    (v) => v.trim().length > 0 || "Este campo é obrigatório",
                    () => {
                        return (
                            !this.nomeJaExiste ||
                            "Já existe uma árvore com este nome"
                        );
                    },
                ],
            },
            formValido: true,
        };
    },
    computed: {
        novaArvore() {
            return !this.$route.params.id;
        },
        testavel() {
            return (
                this.erros.length === 0 &&
                this.arvoreAdmin.texto !== null &&
                this.arvoreAdmin.texto !== ""
            );
        },
        restauravel() {
            return this.arvoreAdmin.habilitada;
        },
        testando() {
            return this.servicoTesteArvore.telaAtual() !== null;
        },
        lancavel() {
            return this.testavel && !this.novaArvore;
        },
        desabilitavel() {
            return this.arvoreAdmin.habilitada;
        },
        apagavel() {
            return !this.arvoreAdmin.habilitada && !this.novaArvore;
        },
        suja() {
            return (
                this.novaArvore ||
                JSON.stringify(this.arvoreAdmin) !== this.arvoreSalva
            );
        },
        salvavel() {
            return this.formValido && this.suja;
        },
        cancelavel() {
            return this.suja && !this.novaArvore;
        },
        ...mapGetters("autenticacao", ["username"]),
        ...mapGetters("contexto", ["contexto", "contextoPendente"]),
    },
    watch: {
        "arvoreAdmin.nome": {
            handler: debounce(function (novoNome) {
                if (this.novaArvore) {
                    servicoArvores.arvoreExiste(novoNome).then((existe) => {
                        this.nomeJaExiste = existe;
                        this.$refs.form.validate();
                    });
                } else {
                    servicoArvores
                        .obterArvorePorNome(novoNome)
                        .then((arvoreAdmin) => {
                            if (arvoreAdmin.id !== this.arvoreAdmin.id) {
                                this.nomeJaExiste = true;
                            } else {
                                this.nomeJaExiste = false;
                            }
                        })
                        .catch(() => {
                            this.nomeJaExiste = false;
                        })
                        .finally(() => {
                            this.$refs.form.validate();
                        });
                }
            }, 300),
            immediate: false,
        },
        contextoPendente(novoContexto) {
            if (novoContexto) {
                this.promptSalvarAntesDeMudarDeContexto();
            }
        },
    },
    mounted() {
        this.escutarMudancaDeContexto();
        this.servicoTesteArvore = new ServicoTesteArvore({
            mapaProcessadores: this.$mapaProcessadores,
        });
        if (!this.novaArvore) {
            servicoArvores.obterArvore(this.$route.params.id).then((arvore) => {
                this.arvoreAdmin = arvore;
                this.arvoreSalva = JSON.stringify(arvore);
                this.verificarCodigo(this.arvoreAdmin.texto);
                this.loading = false;
            });
        } else {
            this.arvoreAdmin = servicoArvores
                .criarArvore({ idContexto: this.contexto.id })
                .then((arvore) => {
                    this.arvoreAdmin = arvore;
                    this.arvoreSalva = JSON.stringify(arvore);
                    this.loading = false;
                });
        }
    },
    beforeDestroy() {
        this.cancelarEscutarMudancaDeContexto();
    },
    beforeRouteLeave(to, from, next) {
        if (!this.suja || this.novaArvore) {
            next();
            return;
        }

        try {
            next(false);
        } catch (e) {
            console.log(e);
        }

        this.promptSalvarAntesDeSair(to);
    },
    methods: {
        escutarMudancaDeContexto() {
            this.interceptar(this._uid);
        },
        cancelarEscutarMudancaDeContexto() {
            this.cancelarInterceptacao(this._uid);
        },
        textoLoaded(arquivo) {
            if (arquivo) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.arvoreAdmin.texto = e.target.result;
                    this.verificarCodigo(this.arvoreAdmin.texto);
                };
                reader.onerror = (e) => {
                    console.log(e);
                };
                reader.readAsText(arquivo);
            } else {
                this.arvoreAdmin.texto = "";
                this.arvoreAdmin.arvoreEmEdicao = {};
            }
        },
        copyToClipBoard() {
            this.copiando = true;
            navigator.clipboard
                .writeText(this.arvoreAdmin.texto)
                .catch((err) => {
                    console.error("Erro ao copiar para o clipboard:", err);
                })
                .finally(() => {
                    this.copiando = false;
                });
        },
        cancelar() {
            this.arvoreAdmin = JSON.parse(this.arvoreSalva);
        },
        verificarCodigo() {
            this.verificando = true;
            servicoArvores
                .verificarCodigo(this.arvoreAdmin.texto)
                .then((data) => {
                    if (data.ok) {
                        this.erros = [];
                        this.arvoreEmEdicao = data.arvore;
                    } else {
                        this.erros = data.erros;
                        this.arvoreEmEdicao = {};
                    }
                    this.verificando = false;
                });
        },
        testarArvore() {
            this.servicoTesteArvore.iniciarTeste(this.arvoreEmEdicao);
        },
        salvar(nextRoute) {
            this.salvando = true;
            this.arvoreAdmin.autor = this.username;
            const arvoreJaExiste = !this.novaArvore;
            servicoArvores
                .salvarArvore(this.arvoreAdmin)
                .then((arvoreAdmin) => {
                    this.arvoreAdmin = arvoreAdmin;
                    this.arvoreSalva = JSON.stringify(this.arvoreAdmin);
                    this.mostrarSucesso("Árvore salva com sucesso!");
                    if (nextRoute) {
                        this.$router.push(nextRoute);
                    } else {
                        if (!arvoreJaExiste) {
                            this.$router.push({
                                name: "DetalheArvore",
                                params: { id: arvoreAdmin.id },
                            });
                        }
                    }
                })
                .catch((err) => {
                    console.error("Erro ao salvar", err);
                    this.mostrarErro("Falha ao salvar arquivo!");
                })
                .finally(() => {
                    this.salvando = false;
                });
        },
        promptSalvarAntesDeMudarDeContexto() {
            if (!this.suja) {
                this.confirmarMudancaContexto();
                this.$router.push({ name: "Home" });
                return;
            }

            this.msgYesCancelDialog =
                "Deseja salvar as alterações antes de trocar de Departamento?";
            this.mostrarYasCancelDialog = true;

            new Promise((resolve) => {
                this.yesCancelDialogResolver = resolve;
            }).then((resultado) => {
                if (resultado === "ok") {
                    this.salvar({ name: "Home" });
                    this.confirmarMudancaContexto();
                } else {
                    this.cancelarMudancaContexto();
                }
            });
        },
        promptSalvarAntesDeSair(to) {
            this.msgYesCancelDialog =
                "Deseja salvar as alterações antes de sair?";
            this.mostrarYasCancelDialog = true;

            new Promise((resolve) => {
                this.yesCancelDialogResolver = resolve;
            }).then((resultado) => {
                if (resultado === "ok") {
                    this.salvar(to);
                }
            });
        },
        promptLancarArvore() {
            this.lancando = true;
            this.msgYesCancelDialog = MSG_LANCAR;
            this.mostrarYasCancelDialog = true;
            new Promise((resolve) => {
                this.yesCancelDialogResolver = resolve;
            })
                .then((resultado) => {
                    if (resultado === "ok") {
                        return this.lancarArvore();
                    }
                })
                .finally(() => {
                    this.mostrarYesCancelDialog = false;
                    this.msgYesCancelDialog = "";
                    this.yesCancelDialogResolver = null;
                    this.lancando = false;
                });
        },
        lancarArvore() {
            this.arvoreAdmin.autor = this.username;
            return servicoArvores
                .lancarArvore(this.arvoreAdmin)
                .then((arvoreAdmin) => {
                    this.arvoreAdmin = arvoreAdmin;
                    this.arvoreSalva = JSON.stringify(this.arvoreAdmin);
                })
                .catch((err) => {
                    console.error("Erro ao lançar árvore", err);
                    this.mostrarErro("Erro ao lançar árvore!");
                });
        },
        voltar() {
            this.$router.push({ name: "Admin" });
        },
        mostrarErro(msg) {
            this.tipoDialogo = "erro";
            this.msgErro = msg;
            this.mostrarDialogo = true;
        },
        mostrarSucesso(msg) {
            this.tipoDialogo = "sucesso";
            this.msgDialogo = msg;
            this.mostrarDialogo = true;
        },
        promptRestaurarArvore() {
            this.restaurando = true;
            this.msgYesCancelDialog = MSG_RESTAURAR;
            this.mostrarYasCancelDialog = true;
            new Promise((resolve) => {
                this.yesCancelDialogResolver = resolve;
            })
                .then((resultado) => {
                    if (resultado === "ok") {
                        return this.restuararArvore();
                    }
                    return;
                })
                .finally(() => {
                    this.mostrarYesCancelDialog = false;
                    this.msgYesCancelDialog = "";
                    this.yesCancelDialogResolver = null;
                    this.restaurando = false;
                });
        },
        restuararArvore() {
            this.arvoreAdmin.texto = this.arvoreAdmin.arvore;
            return servicoArvores
                .salvarArvore(this.arvoreAdmin)
                .then((arvoreAdmin) => {
                    this.arvoreAdmin = arvoreAdmin;
                    return this.arvoreAdmin;
                })
                .catch((err) => {
                    console.error("Erro ao salvar", err);
                    this.mostrarErro("Falha ao salvar arquivo!");
                });
        },
        desabilitarArvore() {
            this.desabilitando = true;
            this.arvoreAdmin.arvore = null;
            this.arvoreAdmin.habilitada = false;
            return servicoArvores
                .desabilitarArvore(this.arvoreAdmin)
                .then((arvoreAdmin) => {
                    this.arvoreAdmin = arvoreAdmin;
                    this.arvoreSalva = JSON.stringify(arvoreAdmin);
                    this.mostrarSucesso("Árvore desablitada com sucesso!");
                    return this.arvoreAdmin;
                })
                .catch((err) => {
                    console.error("Erro ao desabilitar", err);
                    this.mostrarErro("Falha ao desabilitar árvore!");
                })
                .finally(() => {
                    this.desabilitando = false;
                });
        },
        promptApagarArvore() {
            this.apagando = true;
            this.msgYesCancelDialog =
                "Tem certeza que deseja apagar esta árvore?";
            this.mostrarYasCancelDialog = true;
            new Promise((resolve) => {
                this.yesCancelDialogResolver = resolve;
            })
                .then((resultado) => {
                    if (resultado === "ok") {
                        return this.apagarArvore();
                    }
                    return "cancelado";
                })
                .then((result) => {
                    this.mostrarYesCancelDialog = false;
                    this.msgYesCancelDialog = "";
                    this.yesCancelDialogResolver = null;
                    this.apagando = false;
                    if (result !== "cancelado") {
                        this.$router.push({ name: "Admin" });
                    }
                })
                .catch(() => {
                    this.mostrarErro("Falha ao apagar árvore!");
                    this.mostrarYesCancelDialog = false;
                    this.msgYesCancelDialog = "";
                    this.yesCancelDialogResolver = null;
                    this.apagando = false;
                });
        },
        apagarArvore() {
            return servicoArvores.apagarArvore(this.arvoreAdmin);
        },
        download() {
            const texto = this.arvoreAdmin.texto || "";
            const nome =
                (this.arvoreAdmin.nome || "arvore").replace(/[^\w]+/g, "_") +
                ".yaml";
            const blob = new Blob([texto], { type: "text/yaml" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = nome;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        },
        ...mapActions("contexto", [
            "interceptar",
            "cancelarInterceptacao",
            "confirmarMudancaContexto",
            "cancelarMudancaContexto",
        ]),
    },
};
</script>

<style scoped>
.botoes {
    display: flex;
    margin: 20px -12px 0 -12px;
    padding: 0;
    gap: 5px;
}
</style>
